module.exports = __webpack_public_path__ + "static/tiffany-02-37b392e686ed3046786d5e927153c60f.jpg";